"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.search = search;
exports.acquire = acquire;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _immutable = _interopRequireDefault(require("immutable"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_PATH = 'filemanager/api/v3/shutterstock';

function search(_ref) {
  var searchQuery = _ref.searchQuery,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["searchQuery"]);
  return _apiClient.default.get(API_PATH + "/search", {
    query: (0, _extends2.default)({
      q: searchQuery
    }, rest)
  }).then(_immutable.default.fromJS);
}

function acquire(_ref2) {
  var id = _ref2.id,
      filename = _ref2.filename,
      targetFolderId = _ref2.targetFolderId;
  return _apiClient.default.post(API_PATH + "/acquire", {
    timeout: 30000,
    data: {
      fileName: filename,
      id: id,
      targetFolderId: targetFolderId
    }
  }).then();
}